import {
  Component,
  OnInit,
  Input,
  Output,
  ViewEncapsulation,
  EventEmitter,
  forwardRef,
  OnChanges,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';

import { isEqual } from 'lodash';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SelectComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class SelectComponent implements OnInit, OnChanges {
  value = 0;
  disabled = false;
  @Input() items;
  @Output() callback = new EventEmitter<any>();
  @Input() textKey;
  @Input() initBy;
  @Input() defaultText;
  @Input() nullChoice;
  @Input() isDisabled;
  @Input() name;

  private onChange = (value: any) => {};
  private onTouched = () => {};

  ngOnInit() {
    this.defaultText = this.defaultText || 'Выберите значение';
  }

  ngOnChanges(changes: SimpleChanges) {
    // Отслеживаем изменения initBy для корректного обновления отображения
    if (changes && changes.initBy) {
      // Принудительно обновляем отображение при изменении initBy
      // Это необходимо для случаев, когда initBy меняется после инициализации компонента
    }
  }

  onReset() {
    if (this.isDisabled || this.disabled) {
      return;
    }
    this.initBy = null;
    this.onTouched();
    this.onChange(null);
    this.callback.emit(null);
  }

  onSelect(item) {
    if (this.isDisabled || this.disabled) {
      return;
    }
    this.onTouched();
    if (isEqual(item, this.initBy)) {
      return;
    }

    this.initBy = item;
    this.onChange(item);
    this.callback.emit(item);
  }

  getSelected() {
    if (this.textKey) {
      return (this.initBy && this.initBy[this.textKey]) || this.defaultText;
    }

    return this.initBy || this.defaultText;
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }

  writeValue(outsideValue: any) {
    // Model updates must not emit user-change callbacks back into the form.
    this.initBy = outsideValue ?? null;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  updateValue(insideValue: number) {
    this.value = insideValue; // html
    this.onChange(insideValue); // уведомить Forms API
    this.onTouched();
  }
}
